import { render, staticRenderFns } from "./ImmediateCompensationDetailCard.vue?vue&type=template&id=44392bce&scoped=true"
import script from "./ImmediateCompensationDetailCard.vue?vue&type=script&lang=ts"
export * from "./ImmediateCompensationDetailCard.vue?vue&type=script&lang=ts"
import style0 from "./ImmediateCompensationDetailCard.vue?vue&type=style&index=0&id=44392bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44392bce",
  null
  
)

export default component.exports